import type { ReactNode } from 'react'
import React from 'react'
import { CoreDescription } from './CoreDescription'
import { ProBusinessDescription } from './ProBusinessDescription'
import { ProDescription } from './ProDescription'
import { ProPlusBusinessDescription } from './ProPlusBusinessDescription'
import { ProPlusDescription } from './ProPlusDescription'

// @todo: this content in this file should be moved to our i18n lib
export const PlanFeatures = {
  dispatch: {
    feature:
      'Security agents are ready around the clock to request dispatch for break-ins and emergencies',
    id: 'dispatch'
  },
  corePlus: { feature: 'Core plan +', id: 'corePlus' },
  corePlusBusiness: { feature: 'Core Business plan +', id: 'corePlusBusiness' },
  overnightActiveGuard: {
    feature:
      'Overnight SimpliSafe® Active Guard Outdoor Protection (8pm-6am, local)',
    id: 'overnightActiveGuard'
  },
  activeGuard: {
    feature: '24/7 SimpliSafe® Active Guard Outdoor Protection',
    id: 'activeGuard'
  }
} as const

export type PlanFeature = (typeof PlanFeatures)[keyof typeof PlanFeatures]

type PlanData = {
  readonly badge: string
  readonly description: ReactNode
  readonly features: readonly PlanFeature[]
}

export type HybridPlanData = Record<string, PlanData>

export const hybridPlanData: HybridPlanData = {
  SSEDSM2__4867366: {
    badge: '',
    description: <CoreDescription />,
    features: [PlanFeatures.dispatch]
  },
  SSODMONON__13798447: {
    badge: 'NEW',
    description: <ProDescription />,
    features: [PlanFeatures.corePlus, PlanFeatures.overnightActiveGuard]
  },
  SSODMON247__13798553: {
    badge: 'NEW',
    description: <ProPlusDescription />,
    features: [PlanFeatures.corePlus, PlanFeatures.activeGuard]
  },
  // Core Business
  'SSEDSM2-SMB__18994653': {
    badge: 'NEW',
    description: <CoreDescription />,
    features: [PlanFeatures.dispatch]
  },
  // Pro Business
  'SSODMONON-SMB__18994692': {
    badge: 'NEW',
    description: <ProBusinessDescription />,
    features: [PlanFeatures.corePlusBusiness, PlanFeatures.overnightActiveGuard]
  },
  // Pro Plus Business
  'SSODMON247-SMB__18994702': {
    badge: 'NEW',
    description: <ProPlusBusinessDescription />,
    features: [PlanFeatures.corePlusBusiness, PlanFeatures.activeGuard]
  }
}
